import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import MisionVision from './components/MisionVision';
import Servicios from './components/Servicios';
import Estadisticas from './components/Estadisticas';
import Clientes from './components/Clientes';
import PorQueElegirnos from './components/PorQueElegirnos';
import Contacto from './components/Contacto';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <MisionVision />
      <Servicios />
      <Estadisticas />
      <Clientes />
      <PorQueElegirnos />
      <Contacto />
      <Footer />
    </>
  );
}

export default App;
